import { type FC, type ReactNode, Suspense, lazy } from "react";

import { Loader } from "@styled/loader";

import { type RecordsAssistantConfig } from "../runs/report_review/use_records_assistant";

const DashboardRunReportReview = lazy(() =>
  import("@application/components/dashboard/runs/report_review").then((m) => ({
    default: m.DashboardRunReportReview,
  })),
);

// Processed Records section: the inline records review owns the §4g three-band
// layout (utility row + facts line + collapsible card). The slot just hands it
// the existing ProcessRecordsCard and the pages/billable totals — `card` is
// passed through verbatim so the slot doesn't re-declare its large project
// shape. The Medical Summary downloads are derived inside the review from its
// own run query, so both the embedded and standalone mounts show the menu.
export const RecordsReviewSlot: FC<{
  runId: string;
  pages: number;
  billable: number;
  card: ReactNode;
  assistant: RecordsAssistantConfig;
}> = ({ runId, pages, billable, card, assistant }) => (
  <Suspense fallback={<Loader />}>
    <DashboardRunReportReview
      runId={runId}
      embedded
      card={card}
      pages={pages}
      billable={billable}
      assistant={assistant}
    />
  </Suspense>
);
